export const tel = (input?: string): string => {
  if (!input) {
    return '';
  }

  const value = input.toString().trim().replace(/^\+/, '');

  if (value.match(/[^0-9]/)) {
    return input;
  }

  let country: string;
  let city: string;
  let number: string;

  switch (value.length) {
    case 10: // +1PPP####### -> C (PPP) ###-####
      country = '1';
      city = value.slice(0, 3);
      number = value.slice(3);
      break;

    case 11: // +CPPP####### -> CCC (PP) ###-####
      [country] = value;
      city = value.slice(1, 4);
      number = value.slice(4);
      break;

    case 12: // +CCCPP####### -> CCC (PP) ###-####
      country = value.slice(0, 3);
      city = value.slice(3, 5);
      number = value.slice(5);
      break;

    default:
      return input;
  }

  if (country === '1') {
    country = '';
  }

  number = `${number.slice(0, 3)}-${number.slice(3, 5)}-${number.slice(5)}`;

  return `${country} (${city}) ${number}`.trim();
};

export type TelFilter = typeof tel;
